import { render, staticRenderFns } from "./GroupsShow.vue?vue&type=template&id=8e5d8b4c&"
import script from "./GroupsShow.vue?vue&type=script&lang=js&"
export * from "./GroupsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports